// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"415":"4a926415","606":"a94b8af7","647":"78a98135"}[chunkId] + ".js";
};